<template>
    <RegistrationCard/>
</template>

<script>
    import RegistrationCard from "../components/registration_cards/RegistrationCard";


    export default {
        name: "Registration",
        components: {
            RegistrationCard

        },
        data() {
            return {

            };
        }
    };
</script>
